import {
  Box,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import MediaPermissionRequiredModal from './MediaPermissionRequiredModal'
import ProfileCropModal from './ProfileCropModal'
import { useProfilePhotoUpload } from '../../hooks/useProfilePhotoUpload'

const ProfilePhotoPromptModal = ({
  isOpen,
  onClose,
  source = 'global',
  onUploaded,
}: {
  isOpen: boolean
  onClose: () => void
  source?: 'global' | 'booking'
  onUploaded?: () => void
}) => {
  const profilePhotoUpload = useProfilePhotoUpload({
    onUploaded: () => {
      onUploaded?.()
      onClose()
    },
  })

  const bodyText =
    source === 'booking'
      ? 'Add a clear photo of your face so players and coaches can recognize you before the event.'
      : 'Add a clear photo of your face so players and coaches can recognize you across LVBL events.'

  return (
    <>
      <ProfileCropModal
        image={profilePhotoUpload.cropImageSrc}
        isOpen={profilePhotoUpload.isCropModalOpen}
        onClose={profilePhotoUpload.closeCropModal}
        onSave={profilePhotoUpload.saveCroppedPhoto}
        isLoading={profilePhotoUpload.isUploading}
      />
      <MediaPermissionRequiredModal
        isOpen={profilePhotoUpload.isPermissionModalOpen}
        onClose={profilePhotoUpload.closePermissionModal}
      />
      <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
        <ModalOverlay />
        <ModalContent mx="16px">
          <ModalHeader pb="8px">Add a profile photo</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text color="#171C22" fontSize="sm" fontWeight="500" lineHeight="22px">
              {bodyText}
            </Text>
            <Text color="#7E8B9A" fontSize="sm" lineHeight="22px" mt="10px">
              You can change it later in Settings.
            </Text>
            <Box mt="16px">
              <Input
                display="none"
                ref={profilePhotoUpload.fileInputRef}
                type="file"
                accept="image/*"
                onChange={profilePhotoUpload.handleFileInputChange}
              />
            </Box>
          </ModalBody>
          <ModalFooter gap="12px" flexDir="column">
            <Button variant="heavy" w="100%" onClick={profilePhotoUpload.selectProfilePhoto}>
              Upload photo
            </Button>
            <Button variant="light" w="100%" onClick={onClose}>
              Not now
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ProfilePhotoPromptModal
